import React from 'react';
import DatePicker from 'react-datepicker';
import FlipMove from 'react-flip-move';
import { useSelector } from 'react-redux';
import { useTranslation, withTranslation } from 'react-i18next';
import { BsArrowDown, BsArrowUp, BsArrowUpDown } from 'react-icons/bs';

import CustomDatePicker from 'root/components/customDatePicker';
import Pagination from 'root/webapp/shared/pagination/pagination.selector';
import useSportsOutstanding from '../useSportsOutstanding';
import MobileSelect from 'root/webapp/shared/component/mobileSelect/mobileSelect';

const SportsOutstanding = () => {
    const { t } = useTranslation(['history', 'settings', 'transaction', 'providerName']);

    const isMobile = useSelector((s) => s.screen.viewType === 'mobile');

    const {
        OUTSTANDING_LIST,
        COLUMNS,
        SELECT_ENUM,
        datepickerLanguage,
        selectedDateRange,
        currentPage,
        itemPerPage,
        totalCount,
        pagingList,
        sportsOutstanding,
        startDate,
        endDate,
        selectedOutstandingIndex,
        selectedProviderIndex,
        providerList,
        selectedDateRangeDisplay,
        handleSelectFieldChanged,
        handleDateRange,
        handleDateChanged,
        getSportsOutstanding,
        handlePageClick,
        handlePrevNextClick,
    } = useSportsOutstanding();

    function renderDateRangePickSection() {
        return (
            <div className='group-item transaction-date'>
                <div className='title'>
                    <span>{t('transaction:transaction.history.filter.trans_date')}</span>
                    <span className='required'>*</span>
                </div>
                <div className='group'>
                    <ul>
                        {selectedDateRangeDisplay.map((item, i) => (
                            <li key={item} className={i === selectedDateRange ? 'on' : ''} onClick={() => handleDateRange(i)}>
                                <span>{t(item)}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }

    function renderDatePickSection() {
        return (
            <div className='group-item date-select'>
                <div className='title'>{t('transaction:transaction.history.filter.start_date', 'Start Date')}</div>
                <div className='group'>
                    <div className='input-box'>
                        <label>
                            {!isMobile ? (
                                <DatePicker
                                    locale={datepickerLanguage}
                                    autoComplete='off'
                                    type='text'
                                    placeholderText={t('transaction:transaction.history.filter.start_date', 'Start Date')}
                                    selectsStart
                                    selected={startDate}
                                    onChange={(date) => handleDateChanged(date, true)}
                                    dateFormat='yyyy-MM-dd'
                                />
                            ) : (
                                <CustomDatePicker
                                    placeholderText={t('transaction:transaction.history.filter.start_date', 'Start Date')}
                                    selected={startDate}
                                    onChange={(date) => handleDateChanged(date, true)}
                                    popperPlacement='bottom-start'
                                />
                            )}
                            <i className='icon-date' />
                        </label>
                    </div>
                    <span>{t('transaction:transaction.history.filter.to')}</span>
                    <div className='input-box'>
                        <label>
                            {!isMobile ? (
                                <DatePicker
                                    locale={datepickerLanguage}
                                    autoComplete='off'
                                    type='text'
                                    placeholderText={t('transaction:transaction.history.filter.end_date', 'End Date')}
                                    selectsStart
                                    selected={endDate}
                                    onChange={(date) => handleDateChanged(date, false)}
                                    dateFormat='yyyy-MM-dd'
                                />
                            ) : (
                                <CustomDatePicker
                                    placeholderText={t('transaction:transaction.history.filter.end_date', 'End Date')}
                                    selected={endDate}
                                    onChange={(date) => handleDateChanged(date, false)}
                                    popperPlacement='bottom-end'
                                />
                            )}
                            <i className='icon-date' />
                        </label>
                    </div>
                </div>
            </div>
        );
    }

    function renderOutstandingFields() {
        if (!isMobile) {
            return (
                <div className='group-item date-select'>
                    <div className='title'>{t('transaction:transaction.type', 'Outstanding Type')}</div>
                    <div className='group'>
                        <div className='standard-form-field'>
                            <select
                                className='standard-select'
                                value={selectedOutstandingIndex}
                                onChange={(e) => handleSelectFieldChanged(e, SELECT_ENUM.outstandingType.title, isMobile)}
                            >
                                {(OUTSTANDING_LIST || []).map((type) => {
                                    return (
                                        <option key={type.id} value={type.id}>
                                            {t(type?.tabHeader, type?.fallback)}
                                        </option>
                                    );
                                })}
                            </select>
                            <div className='standard-select-arrow'></div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className='group-code group-item date-select'>
                    <MobileSelect
                        itemList={OUTSTANDING_LIST}
                        itemKey={'tabHeader'}
                        onChange={(e) => handleSelectFieldChanged(e, SELECT_ENUM.outstandingType.title, isMobile)}
                        onChangeIndexType={true}
                        itemIndex={selectedOutstandingIndex}
                        title={t('transaction:transaction.type', 'Outstanding Type')}
                    />
                </div>
            );
        }
    }

    function renderProviderListFields() {
        if (!isMobile) {
            return (
                <div className='group-item date-select'>
                    <div className='title'>{t('transaction:transaction.history.provider', 'Provider')}</div>
                    <div className='group'>
                        <div className='standard-form-field'>
                            <select className='standard-select' value={selectedProviderIndex} onChange={(e) => handleSelectFieldChanged(e, SELECT_ENUM.provider.title)}>
                                {(providerList || []).map((type, index) => {
                                    return (
                                        <option key={type.value} value={index}>
                                            {type?.name}
                                        </option>
                                    );
                                })}
                            </select>
                            <div className='standard-select-arrow'></div>
                        </div>
                        {!isMobile ? <div className=''>{renderDateSubmitBtn()}</div> : null}
                    </div>
                </div>
            );
        } else {
            return (
                <div className='group-code group-item date-select'>
                    <MobileSelect
                        itemList={providerList}
                        itemKey={'tabHeader'}
                        onChange={(e) => handleSelectFieldChanged(e, SELECT_ENUM.provider.title, isMobile)}
                        onChangeIndexType={true}
                        itemIndex={selectedProviderIndex}
                        title={t('transaction:transaction.history.provider', 'Provider')}
                    />

                    <div className=''>{renderDateSubmitBtn()}</div>
                </div>
            );
        }
    }

    function renderDateSubmitBtn() {
        return (
            <button className='btn-submit' onClick={() => getSportsOutstanding(0)}>
                {t('transaction:transaction.deposit.cashdeposit.submitbtn', 'Submit').toUpperCase()}
            </button>
        );
    }

    function renderSportsOutstandingSection() {
        return !isMobile ? (
            <div className='history-list'>
                <div className='table-header table-header-6'>
                    <ul>
                        {COLUMNS.map(({ key, sortable }) => (
                            <li className={`history-header-${key}`} key={key}>
                                <span>{t(`transaction:transaction.sportsOutstanding.${key}`, key)}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                {!!sportsOutstanding.length && (
                    <FlipMove className='table-list table-list-6' enterAnimation='fade' leaveAnimation='fade'>
                        {sportsOutstanding.map((history) => (
                            <ul key={history.id}>
                                {COLUMNS.map(({ key, render }) => (
                                    <li className={`history-data-${key}`} key={key}>
                                        <span title={history[key]}>{render(history, t)}</span>
                                    </li>
                                ))}
                            </ul>
                        ))}
                    </FlipMove>
                )}

                {!sportsOutstanding.length && (
                    <div className='table-list'>
                        <span>{t('transaction:transaction.emptyHistory')}</span>
                    </div>
                )}
            </div>
        ) : (
            <div className='history-list freeSpinHistory'>
                <div className='table-container'>
                    <div className='table-header table-header-6'>
                        <ul>
                            {COLUMNS.map(({ key, sortable }) => (
                                <li className={`history-header-${key}`} key={key}>
                                    <span>{t(`transaction:transaction.sportsOutstanding.${key}`, key)}</span>
                                </li>
                            ))}
                        </ul>

                        {!!sportsOutstanding.length && (
                            <FlipMove className='table-list table-list-6' enterAnimation='fade' leaveAnimation='fade'>
                                {sportsOutstanding.map((history) => (
                                    <ul key={history.id}>
                                        {COLUMNS.map(({ key, render }) => (
                                            <li className={`history-data-${key}`} key={key}>
                                                <span>{render(history, t)}</span>
                                            </li>
                                        ))}
                                    </ul>
                                ))}
                            </FlipMove>
                        )}

                        {!sportsOutstanding.length && (
                            <div className='table-list'>
                                <span>{t('transaction:transaction.emptyHistory')}</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div>
            {renderDateRangePickSection()}
            {renderDatePickSection()}
            {renderOutstandingFields()}
            {renderProviderListFields()}
            {renderSportsOutstandingSection()}
            <Pagination
                pagingList={pagingList}
                handlePrevNextClick={handlePrevNextClick}
                totalCount={totalCount}
                currentPage={currentPage}
                itemPerPage={itemPerPage}
                handlePageClick={handlePageClick}
            />
        </div>
    );
};

export default withTranslation(['history', 'settings', 'transaction', 'providerName'])(SportsOutstanding);
